import script from "./Introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=53e61eaf&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e61eaf"]])

export default __exports__